module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./VideoGalleryView.js"));
	}, "VideoGallery");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=VideoGallery!./src/pages/Learn/Tools/VideoGallery/VideoGalleryView.js
// module id = 2230
// module chunks = 367